/* ub-modelagens.js — setas da faixa de modelagens irmas.
   Anima o scrollLeft na mao: o tema usa scroll-behavior smooth !important
   em alguns contextos, o que engole scrollTo({behavior:'smooth'}). */
(function () {
  'use strict';

  var SETA = {
    prev: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">'
        + '<path d="M15 5l-7 7 7 7" stroke="currentColor" stroke-width="2"'
        + ' stroke-linecap="round" stroke-linejoin="round"/></svg>',
    next: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">'
        + '<path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2"'
        + ' stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  function semAnimacao() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function deslizar(trilho, destino, ms) {
    var inicio = trilho.scrollLeft;
    var delta = destino - inicio;
    if (semAnimacao() || Math.abs(delta) < 2) {
      trilho.scrollLeft = destino;
      return;
    }
    var t0 = null;
    function passo(agora) {
      if (t0 === null) t0 = agora;
      var p = Math.min((agora - t0) / ms, 1);
      var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      trilho.scrollLeft = inicio + delta * e;
      if (p < 1) window.requestAnimationFrame(passo);
    }
    window.requestAnimationFrame(passo);
  }

  function montar(janela) {
    if (janela.dataset.ubPronto === '1') return;
    var trilho = janela.querySelector('.ub-irmas__trilho');
    if (!trilho) return;
    janela.dataset.ubPronto = '1';

    var botoes = {};
    ['prev', 'next'].forEach(function (lado) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ub-irmas__seta ub-irmas__seta--' + lado;
      b.innerHTML = SETA[lado];
      b.setAttribute('aria-label', lado === 'prev' ? 'Ver anteriores' : 'Ver proximas');
      b.addEventListener('click', function () {
        var card = trilho.querySelector('.ub-irmas__card, .ub-mini__item');
        var largura = card ? card.getBoundingClientRect().width + 16 : 200;
        var passo = Math.max(largura, Math.floor(trilho.clientWidth * 0.8));
        var alvo = trilho.scrollLeft + (lado === 'prev' ? -passo : passo);
        alvo = Math.max(0, Math.min(alvo, trilho.scrollWidth - trilho.clientWidth));
        deslizar(trilho, alvo, 380);
      });
      janela.appendChild(b);
      botoes[lado] = b;
    });

    function atualizar() {
      var folga = trilho.scrollWidth - trilho.clientWidth;
      var pode = folga > 4;
      var x = trilho.scrollLeft;
      janela.classList.toggle('ub-pode-voltar', pode && x > 4);
      janela.classList.toggle('ub-pode-avancar', pode && x < folga - 4);
      botoes.prev.disabled = !(pode && x > 4);
      botoes.next.disabled = !(pode && x < folga - 4);
    }

    trilho.addEventListener('scroll', function () {
      window.requestAnimationFrame(atualizar);
    }, { passive: true });
    window.addEventListener('resize', atualizar);
    if (window.ResizeObserver) new ResizeObserver(atualizar).observe(trilho);
    trilho.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', atualizar, { once: true });
    });
    atualizar();
  }

  function iniciar() {
    document.querySelectorAll('.ub-irmas__janela').forEach(montar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
  document.addEventListener('shopify:section:load', iniciar);
})();
